module.exports = __webpack_public_path__ + "static/media/iconfont.aac9b5a9.eot";